// extracted by mini-css-extract-plugin
module.exports = {"content":"SamlContent__content___33ucT","heading":"SamlContent__heading___14XaI"};